"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dropdown = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/dropdowns/dropdown"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _inputErrorWrapper = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/inputs/input-error-wrapper"));

var _formik = require("formik");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // TODO: fix why it's not auto-selecting the default value


var SelectField = function SelectField(_ref) {
  var autocomplete = _ref.autocomplete,
      field = _ref.field,
      items = _ref.items,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["autocomplete", "field", "items", "onBlur", "onChange", "value"]);

  var name = field.name;
  return (
    /*#__PURE__*/
    _react.default.createElement(_dropdown.default, _extends({}, field, {
      autocomplete: autocomplete,
      options: items,
      onBlur: function onBlur() {
        return _onBlur(name, true);
      },
      onChange: function onChange(value) {
        _onChange(field.name, value);
      },
      searchable: true,
      value: value
    }, rest))
  );
};

var Dropdown = function Dropdown(_ref2) {
  var autocomplete = _ref2.autocomplete,
      containerClassName = _ref2.containerClassName,
      error = _ref2.error,
      description = _ref2.description,
      fieldName = _ref2.fieldName,
      items = _ref2.items,
      label = _ref2.label,
      placeholder = _ref2.placeholder,
      selectedValue = _ref2.selectedValue,
      setFieldTouched = _ref2.setFieldTouched,
      setFieldValue = _ref2.setFieldValue,
      rest = _objectWithoutProperties(_ref2, ["autocomplete", "containerClassName", "error", "description", "fieldName", "items", "label", "placeholder", "selectedValue", "setFieldTouched", "setFieldValue"]);

  return (
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "form_dropdownWrapper"
    }, !!label &&
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "form_dropdownLabel"
    }, label),
    /*#__PURE__*/
    _react.default.createElement(_inputErrorWrapper.default, {
      containerClassName: (0, _classnames.default)('form_dropdownContainer', containerClassName),
      error: error
    },
    /*#__PURE__*/
    _react.default.createElement(_formik.Field, _extends({
      autoComplete: autocomplete && autocomplete,
      className: "form_dropdownField",
      component: SelectField,
      error: error,
      items: items,
      name: fieldName,
      onBlur: setFieldTouched,
      onChange: setFieldValue,
      placeholder: placeholder,
      selectedValue: selectedValue
    }, rest))), !error && !!description &&
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "form_dropdownDescription",
      secondary: true
    }, description))
  );
};

var _default = Dropdown;
exports.default = _default;